import { CallApi, handleJSONResponse, handleResponse } from './common';
import { ParseLinkResponse } from '@services/tracpage/types/api/parse-link-response';
import { TracPage } from '@services/tracpage/types/trac-page';
import TracLink from '@services/tracpage/types/trac-link';
import InputTracPage from '@services/tracpage/types/db/input-trac-page';

const callAPI = CallApi('tracpage');

export const parseLink = async (url: string): Promise<ParseLinkResponse> => {
  const response = await callAPI(`/link`, 'POST', { url });

  return await handleJSONResponse(response);
};

export const get = async (artistId: string): Promise<TracPage> => {
  const response = await callAPI(`/${artistId}`, 'GET');

  return await handleJSONResponse(response);
};

export const update = async (
  artistId: string,
  tracPage: TracPage
): Promise<TracPage> => {
  const response = await callAPI(`/${artistId}`, 'PUT', tracPage);

  return await handleJSONResponse(response);
};

export const createTracLink = async (
  artistId: string,
  payload: InputTracPage<TracLink>
): Promise<TracLink> => {
  const response = await callAPI(`/${artistId}/traclink`, 'POST', payload);

  return await handleJSONResponse(response);
};

export const updateTracLink = async (
  artistId: string,
  tracLink: TracLink
): Promise<TracLink> => {
  const response = await callAPI(
    `/${artistId}/traclink/${tracLink.id}`,
    'PUT',
    tracLink
  );

  return await handleJSONResponse(response);
};

export const removeTracLink = async (
  artistId: string,
  tracLinkId: string
): Promise<void> => {
  const response = await callAPI(
    `/${artistId}/traclink/${tracLinkId}`,
    'DELETE'
  );

  await handleResponse(response);
};

export const list = async <T extends TracPage | TracLink>(
  artistId: string,
  pageType: T['type']
): Promise<T[]> => {
  const response = await callAPI(`/${artistId}/${pageType}`, 'GET');

  return await handleJSONResponse(response);
};
